export const ONBOARDING_USER_SETTING = 'ONBOARDING_USER_SETTING'
export const ONBOARDING_GLOBAL_USER_SETTING = 'ONBOARDING_GLOBAL_USER_SETTING'
